import { QueryClient } from "@tanstack/react-query";

export const createQueryClient = () => {
  // const mutationCache = new MutationCache({
  //   onSuccess: () => {
  //     queryClient.invalidateQueries();
  //   },
  // });
  const queryClient = new QueryClient({
    // mutationCache,
    defaultOptions: {
      queries: {
        refetchOnReconnect: true,
        refetchOnWindowFocus: false,
        // We don't want to retry queries by default, because in most cases we
        // want to fail early and show a response to the user. There are
        // exceptions, and those can be made on a per-query basis. For others, we
        // should give users controls to retry.
        retry: false,
        refetchOnMount: false,
      },
    },
  });
  return queryClient;
};

export const queryClient = createQueryClient();
